'use strict';

module.exports = {
  isIe9: require('@braintree/browser-detection/is-ie9'),
  isIos: require('@braintree/browser-detection/is-ios'),
  isIosWebview: require('@braintree/browser-detection/is-ios-webview')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/hosted-fields/shared/browser-detection.js
// module id = 496
// module chunks = 0